module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/ogp-512f0d7d16c0eb9b85ca15653cf11d5a.webp";